/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function() {
  const infoBarInner = document.querySelector('.info-bar__inner');
  const mobileItems = document.querySelectorAll('.info-bar__item-mobile');
  const totalMobileItems = mobileItems.length;
  let currentIndex = 0;
  let timer = null;
  let isMobileView = window.innerWidth <= 999;
  let swipeStartListener = null;
  let swipeEndListener = null;
  let navClickListeners = [];

  // Only initialize if mobile items exist
  if (totalMobileItems === 0) return;

  function setupInfoBarSlider() {
    if (isMobileView && infoBarInner && totalMobileItems > 1) {
      // Enable slider for mobile view
      initTimer();
      setupSwipeListeners();
      setupNavButtons();
      toggleNavButtonsVisibility(true);
      enableSliderFunctionality();
    } else {
      // Disable slider for desktop view
      disableSliderFunctionality();
      toggleNavButtonsVisibility(false);
    }
  }

  function enableSliderFunctionality() {
    // Add slider class to enable CSS transitions
    if (infoBarInner) {
      infoBarInner.classList.add('slider-enabled');
    }
  }

  function disableSliderFunctionality() {
    // Clear any running timer
    if (timer) {
      clearInterval(timer);
      timer = null;
    }

    // Reset position
    if (infoBarInner) {
      infoBarInner.style.transform = '';
      infoBarInner.classList.remove('slider-enabled');
    }

    // Remove event listeners
    removeSwipeListeners();
    removeNavButtonListeners();

    // Reset current index
    currentIndex = 0;
  }

  function toggleNavButtonsVisibility(visible) {
    const navButtons = document.querySelectorAll('.info-bar__nav-left, .info-bar__nav-right');
    navButtons.forEach(button => {
      button.style.display = visible ? 'block' : 'none';
    });
  }

  function initTimer() {
    if (timer) {
      clearInterval(timer);
    }

    timer = setInterval(nextSlide, 5000);
  }

  function showSlide(index) {
    if (!isMobileView) return; // Don't slide if not in mobile view

    const translateX = -index * 100;
    infoBarInner.style.transform = `translateX(${translateX}%)`;
  }

  function nextSlide() {
    if (!isMobileView) return; // Don't slide if not in mobile view

    currentIndex = (currentIndex + 1) % totalMobileItems;
    showSlide(currentIndex);
    initTimer();
  }

  function prevSlide() {
    if (!isMobileView) return; // Don't slide if not in mobile view

    currentIndex = (currentIndex - 1 + totalMobileItems) % totalMobileItems;
    showSlide(currentIndex);
    initTimer();
  }

  function setupSwipeListeners() {
    // Remove any existing listeners first
    removeSwipeListeners();

    // Setup new listeners
    swipeStartListener = function(e) {
      const startX = e.touches[0].clientX;

      // Store start position in the element
      this.dataset.startX = startX;

      // Pause the timer during swipe
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    swipeEndListener = function(e) {
      const startX = parseFloat(this.dataset.startX || 0);
      const endX = e.changedTouches[0].clientX;
      const diffX = startX - endX;

      if (diffX > 30) {
        nextSlide();
      } else if (diffX < -30) {
        prevSlide();
      } else {
        // Restart timer if no slide change
        initTimer();
      }
    };

    infoBarInner.addEventListener('touchstart', swipeStartListener, { passive: true });
    infoBarInner.addEventListener('touchend', swipeEndListener);
  }

  function removeSwipeListeners() {
    if (infoBarInner) {
      if (swipeStartListener) {
        infoBarInner.removeEventListener('touchstart', swipeStartListener);
      }
      if (swipeEndListener) {
        infoBarInner.removeEventListener('touchend', swipeEndListener);
      }
    }
  }

  function setupNavButtons() {
    // Remove existing listeners first
    removeNavButtonListeners();

    const leftNav = document.querySelector('.info-bar__nav-left');
    const rightNav = document.querySelector('.info-bar__nav-right');

    if (leftNav) {
      const leftClickListener = function(e) {
        e.preventDefault();
        prevSlide();
      };

      leftNav.addEventListener('click', leftClickListener);
      navClickListeners.push({ element: leftNav, listener: leftClickListener });
    }

    if (rightNav) {
      const rightClickListener = function(e) {
        e.preventDefault();
        nextSlide();
      };

      rightNav.addEventListener('click', rightClickListener);
      navClickListeners.push({ element: rightNav, listener: rightClickListener });
    }
  }

  function removeNavButtonListeners() {
    navClickListeners.forEach(item => {
      item.element.removeEventListener('click', item.listener);
    });
    navClickListeners = [];
  }

  // Add CSS to document head
  const style = document.createElement('style');
  style.textContent = `
    .info-bar__inner {
      transition: transform 0.3s ease;
    }
    .info-bar__inner.slider-enabled .info-bar__item-mobile {
      flex: 0 0 100%;
      max-width: 100%;
    }
    @media screen and (min-width: 1000px) {
      .info-bar__inner {
        transform: none !important;
      }
    }
  `;
  document.head.appendChild(style);

  // Initial setup
  setupInfoBarSlider();

  // Handle resize events
  window.addEventListener('resize', function() {
    const wasInMobileView = isMobileView;
    isMobileView = window.innerWidth <= 999;

    // Only run setup if we're crossing the mobile/desktop threshold
    if (wasInMobileView !== isMobileView) {
      setupInfoBarSlider();
    }
  });
});

document.querySelectorAll('a[href="#cookiebot"]').forEach(link => {
  link.addEventListener('click', function(event) {
      event.preventDefault();
      Cookiebot.renew();
  });
});


// Detect Rebuy cart open/close events
document.addEventListener('DOMContentLoaded', function() {

  // Watch for class changes on the cart element
  const cartObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        const cart = document.getElementById('rebuy-cart');
        if (cart) {
          const isVisible = cart.classList.contains('is-visible');
          if (isVisible) {
            // console.log('Cart opened (detected via class change)');

            // Save the current scroll position when cart opens
            // But don't change the scroll position - just save it for later
            window.rebuyScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

            // Add the fixed position to body without scrolling
            document.body.style.top = `-${window.rebuyScrollPosition}px`;
            document.body.classList.add('rebuy-cart-open');

          } else {
            // console.log('Cart closed (detected via class change)');
            document.body.classList.remove('rebuy-cart-open');

            // Get the scroll position from the body's top property
            const scrollY = document.body.style.top;
            document.body.style.top = '';

            // Restore scroll position when cart closes (immediately)
            if (scrollY) {
              window.scrollTo({
                top: parseInt(scrollY || '0') * -1,
                behavior: 'auto'
              });
            }

          }
        }
      }
    });
  });

  // Start observing
  const observeCart = function() {
    const cart = document.getElementById('rebuy-cart');
    if (cart) {
      cartObserver.observe(cart, { attributes: true });
    }
  };

  // Initial setup
  observeCart();


  // Add CSS to prevent body scrolling when cart is open
  const rebuyCartStyle = document.createElement('style');
  rebuyCartStyle.textContent = `
    body.rebuy-cart-open {
      position: fixed;
      width: 100%;
      overflow: hidden;
      /* Don't set height to 100% to avoid dimension changes */
    }

    #rebuy-cart {
      overflow-y: auto;
      position: fixed;
      z-index: 9999999999;
    }
  `;
  document.head.appendChild(rebuyCartStyle);

  // Watch for cart element being added to the DOM if not present initially
  if (!document.getElementById('rebuy-cart')) {
    const bodyObserver = new MutationObserver(function(mutations) {
      if (document.getElementById('rebuy-cart')) {
        observeCart();
        bodyObserver.disconnect();
      }
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});


class CarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance;
    this.thumbSwiperInstance;
    // Get Attributes attached to the component
    this.layoutType = this.getAttribute("slide-layout-type");
    this.slideSpeed = this.getAttribute("slide-speed");
    this.sliderPerView = this.getAttribute("slide-per-view");
    this.disableTouchMove = !this.hasAttribute("slide-disable-touch-move");
    this.keyboardDisable = !this.hasAttribute("slide-keyboard-disabled");
    // this.initialSlidePerVew = this.getAttribute("slide-initial-per-view")   || '1.3';
    // this.slideToMedia = this.getAttribute('slide-to-media');
    this.slidePaginationType =
      this.getAttribute("slide-pagination-type") || null;
    // this.mediaAutoPlay = this.hasAttribute('slide-media-autoplay');
    // this.responsive_breakpoints =
    //     JSON.parse(this.getAttribute('slide-responsive-breakpoints')) | {};
    this.responsive_breakpoints = JSON.parse(
      this.getAttribute("slide-responsive-breakpoints")
    );
    // Reference elements present inside component
    this.mainSliderElement = this.querySelector("[main-slider]");
    this.spaceBetween = this.getAttribute("space-between") || 20;
    this.thumbNailSliderElement = this.querySelector("[thumbnail-slider]");
    this.prevButton = this.querySelector("[slide-prev]");
    this.nextButton = this.querySelector("[slide-next]");
    this.slideProgressBar = this.querySelector("[slide-progress]");
    this.verticleThumbnail = this.getAttribute("verticle-thumbnail");
    this.sliderAutoplay = this.getAttribute("slide-autoplay") || "true";
    this.sliderAutoplayDelay = this.getAttribute("slide-autoplay-delay") || 5; // default 5 seconds
    this.sliderAnimation = this.getAttribute("slide-animation");
    this.slidePositionLeftIfLess = !this.hasAttribute("slide-no-center");
    this.sliderController = this.querySelector("[slider-controller]");
    this.customPagination = this.querySelector("[slide-pagination]");
    // query play/pause buttons if present
    this.playButton = this.querySelector('.swiper-button-play');
    this.pauseButton = this.querySelector('.swiper-button-pause');
    this.didCarouselInitiate = false;
    this.customNavigation =
      JSON.parse(this.getAttribute("slide-custom-nav-arrows")) || null;
    if (this.customNavigation) {
      let { nextArrow, prevArrow } = this.customNavigation;
      if (!nextArrow || !prevArrow)
        throw new Error(
          "Make sure to add next arrow and prevArrow key: values properly"
        );
      this.nextButton = this.querySelector(nextArrow);
      this.prevButton = this.querySelector(prevArrow);
    }
    this.loopSlide = this.hasAttribute("slide-loop");
    this.enableAfterInteraction = this.hasAttribute(
      "slide-enable-after-interaction"
    );
    this._animateOnSlideChange = this.hasAttribute("animate-on-slide-change");
    let options = {
      root: document,
      rootMargin: "0px",
      threshold: 0.01,
    };
    this.intersectionElement = this.hasAttribute("intersection-element");
    this.intersectionElement &&
      HELPER_UTIL.trigerElementFunctionalityInView(this, options);
  }

  //changes color of control on each slide change
  dynamic_navigation_color(swiperInstance) {
    const activeSlideElement =
      swiperInstance.slides[swiperInstance.activeIndex];
    let colorSchemeClass = activeSlideElement.getAttribute("data-color-scheme");
    this.sliderController.className = "";
    this.sliderController.classList.add(colorSchemeClass);
  }

  // Check for autoplay
  getSlideAutoplayParams() {
    if (this.sliderAutoplay == "true") {
      return {
        autoplay: {
          delay: parseInt(this.sliderAutoplayDelay) * 1000,
          pauseOnMouseEnter: true,
          disableOnInteraction: !this.enableAfterInteraction,
        },
      };
    }
    return {};
  }

  getSlideAnimationParams() {
    if (this.sliderAnimation === "fade") {
      return {
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
      };
    }
    return {};
  }

  // Events for Swiper
  // Fired when swiper is initialize
  handleSliderAfterInitialization(swiperInstance) {
    this.classList.add("carousel-active");

    this.has_dynamic_navigation_color = this.hasAttribute(
      "dynamic-navigation-color"
    );
    if (this.has_dynamic_navigation_color && this.sliderController) {
      this.dynamic_navigation_color(swiperInstance);
    }
    setTimeout(() => {
      this.slideChangeAnimation(swiperInstance);
    }, 0);
  }

  // Run set of functions after slide change event is fired
  handleFunctionalityAfterSlideChange(swiperInstance) {
    this.autoPlayMediaOnActiveSlide(swiperInstance);

    if (this.has_dynamic_navigation_color && this.sliderController) {
      this.dynamic_navigation_color(swiperInstance);
    }

    this.slideChangeAnimation(swiperInstance);
  }

  autoPlayMediaOnActiveSlide(swiperInstance) {
    // Look for element which has video elements
    const activeSlideElement =
      swiperInstance.slides[swiperInstance.activeIndex];
    const mediaElement = activeSlideElement?.querySelector("[data-media-type]");
    if (mediaElement) {
      mediaElement.hasAttribute("media-autoplay") &&
        HELPER_UTIL.playMedia(mediaElement);
    }
  }

  // Run to animate elements on slide change
  slideChangeAnimation(swiperInstance) {
    if (!window.animation) return;
    const activeSlideElement =
      swiperInstance.slides[swiperInstance.activeIndex];
    if (this._animateOnSlideChange && activeSlideElement) {
      const animateElements =
        activeSlideElement.querySelectorAll("animation-reveal");
      animateElements &&
        animateElements.forEach((animateElement) => {
          animateElement.animateImageTxt(animateElement);
        });
    }
  }

  // Callable Methods for swiper
  // Method that initialize corousel for that component
  initSlider(sliderElement = this.mainSliderElement) {
    let sliderReponsiveData = this.responsive_breakpoints || {};
    if (this.thumbNailSliderElement) {
      this.initThumbnailSlider();
    }
    this.swiperInstance = new Swiper(sliderElement, {
      ally: true,
      lazy: true,
      speed: Number(this.slideSpeed) || 600,
      allowTouchMove: this.disableTouchMove,
      slidesPerView: this.sliderPerView,
      spaceBetween: Number(this.spaceBetween),
      preventClicksPropagation: false,
      centerInsufficientSlides: this.slidePositionLeftIfLess,
      threshold: 15,
      loop: this.loopSlide,
      // preventClicks: false,
      navigation: {
        nextEl: this.nextButton,
        prevEl: this.prevButton,
      },
      thumbs: {
        swiper: this.thumbSwiperInstance,
      },
      keyboard: {
        enabled: this.keyboardDisable,
      },
      pagination: {
        el: this.customPagination,
        clickable: true,
      },
      // Responsive breakpoints
      breakpoints: {
        ...sliderReponsiveData,
      },
      ...this.getSlideAutoplayParams(),
      ...this.getSlideAnimationParams(),
      // Listening to some slider events
      on: {
        init: this.handleSliderAfterInitialization.bind(this), // When swiper is initialized
        slideChange: this.handleFunctionalityAfterSlideChange.bind(this),
      },
    });


    // Play / Pause setup
    const swiper = this.swiperInstance;
    if (this.playButton && this.pauseButton) {
      // Click handlers
      this._playClickHandler = () => {
        // ensure autoplay params exist
        if (!swiper.params.autoplay || !swiper.params.autoplay.delay) {
          swiper.params.autoplay = {
            delay: (Number(this.sliderAutoplayDelay) || 5) * 1000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          };
        }
        swiper.autoplay.start();
        this.playButton.style.display = 'none';
        this.pauseButton.style.display = 'inline-flex';
        this.playButton.setAttribute('aria-pressed','false');
        this.pauseButton.setAttribute('aria-pressed','true');
      };

      this._pauseClickHandler = () => {
        swiper.autoplay.stop();
        this.playButton.style.display = 'inline-flex';
        this.pauseButton.style.display = 'none';
        this.playButton.setAttribute('aria-pressed','true');
        this.pauseButton.setAttribute('aria-pressed','false');
      };

      this.playButton.addEventListener('click', this._playClickHandler);
      this.pauseButton.addEventListener('click', this._pauseClickHandler);

      // Reflect current autoplay state
      const isAutoplayRunning = !!(swiper.autoplay && swiper.autoplay.running);
      this.playButton.style.display = isAutoplayRunning ? 'none' : 'inline-flex';
      this.pauseButton.style.display = isAutoplayRunning ? 'inline-flex' : 'none';

      // Update buttons on autoplay events
      swiper.on('autoplayStart', () => {
        this.playButton.style.display = 'none';
        this.pauseButton.style.display = 'inline-flex';
      });
      swiper.on('autoplayStop', () => {
        this.playButton.style.display = 'inline-flex';
        this.pauseButton.style.display = 'none';
      });
    }




  }

  initThumbnailSlider() {
    this.thumbnailResponsiveBreakpoints = {
      992: {
        slidesPerView: this.verticleThumbnail == "true" ? "auto" : 4,
        direction: this.verticleThumbnail == "true" ? "vertical" : "horizontal",
      },
      767: {
        slidesPerView: 4.8,
        direction: "horizontal",
      },
    };
    if (this.hasAttribute("thumbnail-responsive-breakpoints")) {
      this.thumbnailResponsiveBreakpoints = JSON.parse(
        this.getAttribute("thumbnail-responsive-breakpoints")
      );
    }
    this.thumbSwiperInstance = new Swiper(this.thumbNailSliderElement, {
      ally: true,
      spaceBetween: Number(this.spaceBetween) || 20,
      slidesPerView: 3.8,
      freeMode: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      centerInsufficientSlides: this.verticleThumbnail === "false",
      threshold: 15,
      keyboard: {
        enabled: true,
      },
      breakpoints: { ...this.thumbnailResponsiveBreakpoints },
    });
  }

  // Called when slider is connected to layout
  connectedCallback() {
    if (this.layoutType == "carousel") {
      if (this.intersectionElement) {
        this.addEventListener(_EVENT_HELPER.elementIsInCurrentView, () => {
          if (this.didCarouselInitiate) return;
          // If layout type is set to carouse then Show carousel

          this.initSlider();
          this.didCarouselInitiate = true;
        });
      } else {
        this.initSlider();
      }
    }
  }

  disconnectedCallback() {
    // Destroy Swiper instance if remove from page
    this.swiperInstance?.destroy();
    this.thumbSwiperInstance && this.thumbSwiperInstance?.destroy();
  }
}


customElements.define("carousel-component", CarouselComponent);

const custom = function() {
  const initContactForm = function(){
    const form = document.querySelector('#ContactForm');
    if (!form) {
      return;
    }

    form.addEventListener('submit', function(e){
      e.preventDefault();
      e.stopPropagation();

      const formData = new FormData(e.target);
      const data = Object.fromEntries(formData);
      const endpoint = 'https://api.shopcheck.huddled.com/public/shopify/contact';
      const store = window.location.origin;
      const fields = {};
      const messageContainerNode = form.querySelector('.js-message');

      if (!messageContainerNode) {
        return;
      }

      const messageNode = messageContainerNode.querySelector('span');

      messageNode.innerHTML = '';
      messageContainerNode.classList.add('visually-hidden');
      messageContainerNode.querySelector('.icon-error').classList.add('visually-hidden');
      messageContainerNode.querySelector('.icon-success').classList.add('visually-hidden');

      for (const [key, value] of Object.entries(data)) {
        if (key.startsWith('contact[')) {
          const fieldName = key.replace('contact[', '').replace(']', '');
          if (fieldName.toLowerCase() === 'consent') {
            continue;
          }

          // Preserve "Request Type" field name as-is, lowercase all others
          if (fieldName === 'Request Type') {
            fields['Request Type'] = value;
          } else {
            fields[fieldName.toLowerCase()] = value;
          }
        }
      }

      if (!fields.hasOwnProperty('email') || !fields.email || !fields.hasOwnProperty('message') || !fields.message) {
        messageNode.innerHTML = 'Please fill in all required fields.';
        messageContainerNode.classList.remove('visually-hidden');
        messageContainerNode.querySelector('.icon-error').classList.remove('visually-hidden');
        messageContainerNode.querySelector('.icon-success').classList.add('visually-hidden');
        return;
      }

      const requestData = { store, fields };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      };

      fetch(endpoint, requestOptions)
        .then(response => response.json())
        .then(() => {
          form.reset();
          e.target.classList.add('message-sent');
        })
        .catch(() => {
          messageNode.innerHTML = 'An error occurred while submitting the form. Please try again later.';
          messageContainerNode.classList.remove('visually-hidden');
          messageContainerNode.querySelector('.icon-error').classList.remove('visually-hidden');
          messageContainerNode.querySelector('.icon-success').classList.add('visually-hidden');
        });
    }, { capture: true });
  }

  return {
      init : function() {
          initContactForm();
      }
  }
}();

document.addEventListener('DOMContentLoaded', ()=> {
  custom.init();
})